window.addEventListener("DOMContentLoaded", () => {

  Array.from(document.getElementsByTagName("form")).forEach(form => {

    function activateSpinner(target: EventTarget | null) {
      (target as HTMLElement)?.querySelectorAll(".btn-group").forEach(element => element.classList.add("wait"));
    }

    const addWaitEvent = new Event("addWait");

    // otherwise listen for form submit
    form.addEventListener("submit", event => {
      activateSpinner(event.target);
      event.target?.dispatchEvent(addWaitEvent);
    });

  });

});
